<template>
	<div class="claims-container">
		<div class="claims-count">
			<div>
				<v-alert type="error" v-if="error_msg.length !== 0" dense>
					{{ error_msg }}
				</v-alert>
			</div>
			<div>
				<v-select
					style="width: 160px"
					v-model="selected"
					:items="selection_items"
					:menu-props="{ bottom: true, offsetY: true}"
					color="rgba(25, 42, 62, 0.7)"
					item-color="rgba(25, 42, 62, 0.7)"
					append-icon="mdi-chevron-down"
					hide-details
					return-object
					dense
					solo
					@change="onTimeChanged($event)"
				></v-select>
			</div>
		</div>
		<div v-if="!$vuetify.breakpoint.smAndDown" class="claims-count mt-2">
			<div v-for="claim of claims"  :key="claim.name" class="mx-2">
				<div
					class="claims-count-item" 
					:class="hover_name === claim.name || click_name === claim.name ? 'claims-count-item-hover':''"
					@mouseover="hover_name = claim.name"
					@mouseout="hover_name = ''"
					@click="onClaimsClick(claim)">
					<div :class="claim.name === 'Rejected'? 'special':''">{{ claim.name }}</div>
					<div :class="claim.name === 'Rejected'? 'special':''">{{ claim.value.length }}</div>
				</div>
			</div>
		</div>
		<v-row v-if="$vuetify.breakpoint.smAndDown" class="mt-1">
			<v-col v-for="claim of claims"  :key="claim.name" :cols="$vuetify.breakpoint.smAndDown ? 4:3">
				<div
					class="claims-count-item" 
					:class="hover_name === claim.name || click_name === claim.name ? 'claims-count-item-hover':''"
					@mouseover="hover_name = claim.name"
					@mouseout="hover_name = ''"
					@click="onClaimsClick(claim)">
					<div :class="claim.name === 'Rejected'? 'special':''">{{ claim.name }}</div>
					<div :class="claim.name === 'Rejected'? 'special':''">{{ claim.value.length }}</div>
				</div>
			</v-col>
		</v-row>
		<div v-if="show_claims.length > 0">
			<v-container
				style="max-height: 100px"
				class="overflow-y-auto pa-0 mt-4"
			>
				<v-row
					v-for="claim in show_claims" :key="claim.id"
					style="height: 48px"
					no-gutters
					class="claims-count mt-1"
				>
					<v-col cols="3">
						<div v-if="claim.status === claim_statuses.draft.text || claim.status === claim_statuses.pending.text" class="claim-user">
							<v-user-avatar
								size="24"
								class="text-caption text-decoration-none"
								:code="claim.supplier.code"
								:image="claim.supplier.image"
							/>
							<div class="ml-2 claim-text claim-name" v-if="claim.supplier.id === user_abid">You</div>
							<div class="ml-2 claim-text claim-name" v-else>{{ claim.supplier.display_name }}</div>
						</div>
						<div v-else class="claim-user">
							<v-user-avatar
								size="24"
								class="text-caption text-decoration-none"
								:code="claim.approval_by.code"
								:image="claim.approval_by.image"
							/>
							<div class="ml-2 claim-text claim-name" v-if="claim.approval_by.id === user_abid">You</div>
							<div class="ml-2 claim-text claim-name" v-else>{{ claim.approval_by.display_name }}</div>
						</div>
					</v-col>
					<v-col cols="6">
						<div class="claim-link ml-1" @click="onClaimItem(claim)">{{ claim.desc }}</div>
						<div v-if="claim.status === claim_statuses.rejected.text" class="claim-text reason-text  ml-1">{{ claim.remark }}</div>
					</v-col>
					<v-col cols="3" class="claim-text claim-date">
						<div v-if="claim.status === claim_statuses.draft.text">{{ formatDate(claim.date) }}</div>
						<div v-if="claim.status === claim_statuses.rejected.text && claim.remark_date">{{ formatDate(claim.remark_date) }}</div>
						<div v-if="claim.status !== claim_statuses.draft.text && claim.status !== claim_statuses.rejected.text">{{ formatDate(claim.submitted_date) }}</div>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import config from "@/config.js";

const Date_Selection = [
	{text: 'Last month',  value: 'last_month'},
	{text: 'Last week',  value: 'last_week'},
	{text: 'This week',  value: 'this_week'},
	{text: 'This month',  value: 'this_month'},
	{text: 'Year to date',  value: 'year_date'},
	{text: 'This financial year to date',  value: 'financial_year_date'},
];
const CLAIM_STATUSES = config.claim_statuses;

export default {
	name: 'MyExpenseClaims',
	data() {
		this.claim_statuses = CLAIM_STATUSES;
		this.remark_date_flag = config.remark_date_flag;
		return {
			error_msg: '',
			loading: false,
			current_period: null,
			selection_items: Date_Selection,
			selected: {text: 'This month',  value: 'this_month'},
			claims: [],
			show_claims: [],
			hover_name: '',
			click_name: '',
		}
	},
	computed: {
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
	},
	created() {
		this.getCurrentPeriod();

		const start_date = moment().startOf('month').format('YYYY-MM-DD'); 
		const end_date = moment().endOf('month').format('YYYY-MM-DD'); 
		this.getClaims(start_date, end_date);
	},
	methods: {
		getCurrentPeriod() {
			let url = "/api/config/periods/current_period";

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.current_period = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		getClaims(start_date, end_date) {
			this.loading = true;
			const params = [];
			const statusses = [];
			for (const status of Object.values(CLAIM_STATUSES)) {
				statusses.push(status.value);
			}
			params.push("statusses=" + statusses);
			params.push("ignore_deleted=" + true);
			params.push("employees=" + this.user_abid);

			let url = "/api/expenses/claims";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;
					if (status === 'OK') {
						const claims_sub  = {};
						for (const code_obj of Object.values(CLAIM_STATUSES)) {
							claims_sub[`${code_obj.text}`] = [];
						}

						const date_tmp = data.filter(d => { return d.date >= start_date });
						const date_result = date_tmp.filter(d => { return d.date <= end_date });
						date_result.forEach(d => {
							if (d.status === CLAIM_STATUSES.rejected.text) {
								const remark_split_arr = d.remark ? d.remark.split(this.remark_date_flag) : [null, null];
								const remark = remark_split_arr[0];
								const remark_date = remark_split_arr[1];
								d['remark'] = remark ? remark : '';
								d['remark_date'] = remark_date ? remark_date : null;
							}
							claims_sub[`${d.status}`].push(d);
						});

						const claim_tmp = [];
						for (const [key, value] of Object.entries(claims_sub)) {
							const obj = {
								name: key,
								value: value
							};
							claim_tmp.push(obj);
						}

						this.claims = claim_tmp;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch(msg => {
					this.error_msg = msg.message;
					this.loading = false;
				});
		},
		onTimeChanged(time) {
			this.show_claims = [];
			this.click_name = '';
			this.error_msg = '';
      
			let start_date = '';
			let end_date = '';

			if (time.value === 'last_month') {
				start_date = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'); 
				end_date = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'); 
			}
			if (time.value === 'last_week') {
				start_date = moment().subtract(1, 'weeks').startOf('weeks').format('YYYY-MM-DD'); 
				end_date = moment().subtract(1, 'weeks').endOf('weeks').format('YYYY-MM-DD'); 
			}
			if (time.value === 'this_week') {
				start_date = moment().startOf('weeks').format('YYYY-MM-DD'); 
				end_date = moment().endOf('weeks').format('YYYY-MM-DD'); 
			}
			if (time.value === 'this_month') {
				start_date = moment().startOf('month').format('YYYY-MM-DD'); 
				end_date = moment().endOf('month').format('YYYY-MM-DD'); 
			}
			if (time.value === 'year_date') {
				start_date = moment().startOf('year').format('YYYY-MM-DD'); 
				end_date = moment().format('YYYY-MM-DD'); 
			}
			if (time.value === 'financial_year_date') {
				start_date = this.current_period.start_date;
				end_date = moment().format('YYYY-MM-DD'); 
			}

			this.getClaims(start_date, end_date);
		},
		onClaimsClick(cliam) {
			this.click_name = cliam.name;
			this.show_claims = [];
			this.show_claims = cliam.value;
			this.error_msg = '';
		},
		onClaimItem(claim) {
			this.$router.push({ name: 'Edit Claim', params: { 'id': claim.id }});
		},
		formatDate(date) {
			return moment(date).format('DD MMM YYYY');
		}
	}
}
</script>
<style lang="scss" scoped>
.claims-container {
  padding: 6px 16px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  border-radius: 0 0 4px 4px;
}
.claims-count {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.claims-count-item {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
}
.claims-count-item-hover {
  background-color: #E8EAEC;
  border-radius: 4px;
}

.claim-user {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.claim-link {
  width: 100%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #C18014;
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:hover {
    cursor: pointer;
  }
}
.claim-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.claim-link-text {
  color: rgba(25, 42, 62, 0.7);
}
.claim-name {
  color: rgba(25, 42, 62, 0.5);
}
.claim-date {
  color: rgba(25, 42, 62, 0.7);
  text-align: right;
}
.reason-text {
  color: #192A3E;
}
.special {
  color: #F45252;
}
</style>